import { createClient } from './http';
import { env } from '../config/env';

const api = createClient(env.DELIVERY_PARTNER_BASE_URL || env.AUTH_BASE_URL);

export const driverWalletService = {
  listWithdrawRequests(params = {}) {
    return api.get('/api/admin/wallet/withdraw-requests', { params });
  },
  getDriverWallet(partnerId) {
    return api.get(`/api/admin/wallet/driver/${partnerId}`);
  },
  approveWithdrawal(id, body = {}) {
    return api.post(`/api/admin/wallet/withdraw-requests/${id}/approve`, body);
  },
  markWithdrawalPaid(id, body = {}) {
    return api.post(`/api/admin/wallet/withdraw-requests/${id}/mark-paid`, body);
  },
  rejectWithdrawal(id, body = {}) {
    return api.post(`/api/admin/wallet/withdraw-requests/${id}/reject`, body);
  },
  manualAdjustment(body = {}) {
    return api.post('/api/admin/wallet/manual-adjustment', body);
  },
};
